import React from 'react';
import { useLanguage } from '../contexts/LanguageContext.jsx';
import { trackEvent } from '../services/analytics.js';
import { LINKS, ICONS } from '../constants.js';
import { Button, Svg, Sym } from './ui.jsx';

// Shared by Hero and CTA strip: same three buttons, different analytics event/section.
export const DownloadButtons = ({ event, section, center = false }) => {
  const { t } = useLanguage();
  const track = (destination) => trackEvent(event, { destination, section });
  return (
    <div className={'cta-row' + (center ? ' center' : '')}>
      <a href={LINKS.android} target="_blank" rel="noopener noreferrer" onClick={() => track('google_play')} aria-label={t.hero.ctaAndroid}>
        <Button variant="primary" size="lg"><Svg d={ICONS.android} />{t.hero.ctaAndroid}</Button>
      </a>
      <a href={LINKS.web} target="_blank" rel="noopener noreferrer" onClick={() => track('web_pwa')} aria-label={t.hero.ctaWeb}>
        <Button variant="cinematic" size="lg"><Sym name="language" size={20} />{t.hero.ctaWeb}</Button>
      </a>
      <a href={LINKS.web} target="_blank" rel="noopener noreferrer" onClick={() => track('ios_webapp')} aria-label="iOS">
        <Button variant="ghost" size="lg"><Svg d={ICONS.apple} />iOS</Button>
      </a>
    </div>
  );
};

